/* src/theme/customTheme.js - Última Modificación: 03-01-2026 */
/* ---------------------------------------------------------- */

export const getCustomTheme = (baseTheme, modo) => {
  const isDark = modo === 'dark';

  /* ========================= */
  /* 🎨 TOKENS – DARK MODE     */
  /* ========================= */
  const uiDark = {
    modalBg: '#171717',
    surfaceBg: '#191919',

    brandAccent: '#F5A53D',

    navHoverBg: 'rgba(255,255,255,0.12)',

    menuBg: '#202020',
    menuHoverBg: 'rgba(148,163,184,0.12)',
    menuSelectedBg: 'rgba(56,189,248,0.18)',

    surfaceShadow: '0 4px 12px rgba(0,0,0,0.45)',
    modalShadow: '0 12px 32px rgba(0,0,0,0.55)',

    primaryActionBg: 'rgba(56, 189, 248, 0.22)',
    primaryActionBgHover: 'rgba(56, 189, 248, 0.32)',
    primaryActionBorder: 'rgba(56, 189, 248, 0.35)',
    primaryActionBorderHover: 'rgba(56, 189, 248, 0.6)',
    primaryActionText: '#38bdf8',

    borderSubtle: 'rgba(148,163,184,0.25)',
    textPrimary: '#c3c5cb', /*'#d3d6dc','#e5e7eb',*/
    textSecondary: '#9ca3af',
    textMuted: '#94a3b8',
    hoverBg: 'rgba(148,163,184,0.08)',
    selectedBg: 'rgba(56,189,248,0.18)',
    focus: '#38bdf8',
    titleAccent: '#D1A415',
    breadcrumbBg: 'rgba(15, 23, 42, 0.85)',
    navBg: '#0f3a5f',

    /* Botones Pdf y Csv */
    exportActionBg: 'rgba(148,163,184,0.18)',
    exportActionBgHover: 'rgba(148,163,184,0.28)',
    exportActionText: '#e5e7eb',
    exportActionBorder: 'rgba(148,163,184,0.35)',

    status: {
      success: {
        bg: '#166534',
        text: '#e5e7eb',
        border: '#166534',
      },
      warning: {
        bg: '#FFA500',  // #fef3c7
        text: '#e5e7eb',
        border: '#FFA500',  //#fcd34d
      },
      paid: {
        bg: '#0000FF',
        text: '#e5e7eb',
        border: '#0000FF',
      },
      error: {
        bg: 'rgba(239,68,68,0.18)',
        text: '#f87171',
        border: 'rgba(239,68,68,0.35)',
      },
    },
  };

  /* ========================= */
  /* 🎨 TOKENS – LIGHT MODE    */
  /* ========================= */
  const uiLight = {
    modalBg: '#E5E5E5',
    surfaceBg: '#F0F0F0',

    brandAccent: '#F5A53D',

    /* Menu Principal */
    menuBg: '#ffffff',
    menuHoverBg: '#e5e7eb',
    menuSelectedBg: '#cbd5e1',

    /* Sombra Modal */
    surfaceShadow: '0 4px 12px rgba(0,0,0,0.15)',
    modalShadow: '0 12px 32px rgba(0,0,0,0.18)',

    /* Acciones Primarias */
    primaryActionBg: '#2563eb',
    primaryActionBgHover: '#1d4ed8',
    primaryActionText: '#ffffff',

    /* Acciones Secundarias */
    secondaryActionBg: '#E5E7EB',
    secondaryActionBgHover: '#B6C2CF',
    secondaryActionText: '#1e293b',
    secondaryActionBorder: 'rgba(0,0,0,0.16)',

    borderSubtle: 'rgba(0,0,0,0.12)',
    textPrimary: '#1e293b',
    textSecondary: '#475569',
    textMuted: '#64748b',
    hoverBg: '#e2e8f0',
    focus: '#2563eb',
    titleAccent: '#A16207',
    breadcrumbBg: 'rgba(255,255,255,0.9)',

    /* Sidebar */
    navBg: '#1e4f7a',
    navHoverBg: 'rgba(30, 41, 59, 0.9)',
    selectedBg: '#cbd5e1',

    /* Botones Pdf y Csv */
    exportActionBg: '#e0f2fe',
    exportActionBgHover: '#bae6fd',
    exportActionText: '#0369a1',
    exportActionBorder: '#0369a1',

    status: {
      success: {
        bg: '#166534',
        text: '#e5e7eb',
        border: '#166534',
      },
      warning: {
        bg: '#FFA500',  // #fef3c7
        text: '#e5e7eb',
        border: '#FFA500',  //#fcd34d
      },
      paid: {
        bg: '#0000FF',
        text: '#e5e7eb',
        border: '#0000FF',
      },
      error: {
        bg: '#fee2e2',
        text: '#991b1b',
        border: '#fca5a5',
      },
    },
  };

  /* ========================= */
  /* 🎯 TOKEN ACTIVO           */
  /* ========================= */
  const uiBase = isDark ? uiDark : uiLight;

  /* ========================= */
  /* 🎯 TOKENS DERIVADOS       */
  /* ========================= */
  const ui = {
    ...uiBase,

    /* Actions */
    primaryAction: uiBase.primaryActionBg,
    primaryActionHover: uiBase.primaryActionBgHover,
    primaryActionBorder: uiBase.primaryActionBorder,
    primaryActionBorderHover: uiBase.primaryActionBorderHover,
    primaryActionText: uiBase.primaryActionText,

    cardTitleAccent: {
      fontSize: '0.95rem',
      fontWeight: 600,
      letterSpacing: '0.02em',
      color: isDark ? uiBase.titleAccent : uiBase.textPrimary
    },

  /* ========================= */
  /* 🧊 GLASS SYSTEM (FIX)     */
  /* ========================= */
  glass: {
    background: isDark
      ? 'rgba(255,255,255,0.04)'
      : '#ffffff',

    backgroundSoft: isDark
      ? 'rgba(255,255,255,0.02)'
      : '#ffffff',

    border: isDark
      ? 'rgba(255,255,255,0.08)'
      : 'rgba(0,0,0,0.08)',

    hover: isDark
      ? 'rgba(255,255,255,0.08)'
      : '#f1f5f9',

    shadow: isDark
      ? '0 8px 30px rgba(0,0,0,0.35)'
      : '0 8px 25px rgba(0,0,0,0.08)',

    shadowHover: isDark
      ? '0 12px 40px rgba(0,0,0,0.45)'
      : '0 12px 30px rgba(0,0,0,0.12)',
  },

  /* ========================= */
  /* 📊 CHART TOKENS           */
  /* ========================= */
  chartGrid: isDark
    ? 'rgba(255,255,255,0.06)'
    : 'rgba(0,0,0,0.06)',

  chartTick: isDark
    ? 'rgba(255,255,255,0.6)'
    : '#475569',

  tooltipBg: isDark
    ? 'rgba(20,20,20,0.85)'
    : '#ffffff',

  };

  return {
    ...baseTheme,

    /* 👈 Exponer tokens */
    custom: {
      ui,
      uiDark, // dark siempre disponible
    },

    palette: {
      mode: modo,

      background: {
        default: isDark ? '#020617' : '#dcdcdc',
        paper: ui.modalBg,
      },

      text: {
        primary: ui.textPrimary,
        secondary: ui.textSecondary,
      },

      primary: {
        main: ui.focus,
      },
    },

    components: {
      /* ========================= */
      /* 🧾 INPUTS                */
      /* ========================= */
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: ui.surfaceBg,
            borderRadius: 8,

            '&:hover': {
              backgroundColor: ui.surfaceBg,
            },

            '&.Mui-focused': {
              backgroundColor: ui.surfaceBg,
            },

            '&.Mui-disabled': {
              backgroundColor: isDark ? ui.surfaceBg : '#e5e7eb',
              color: ui.textMuted,
            },
          },

          notchedOutline: {
            borderColor: ui.borderSubtle,
          },

          input: {
            color: ui.textPrimary,

            '&::placeholder': {
              color: ui.textMuted,
              opacity: 1,
            },
          },
        },
      },

      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: ui.textSecondary,

            '&.Mui-focused': {
              color: ui.focus,
            },
          },

          outlined: {
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -6px) scale(0.75)',
              padding: '0 6px',
              backgroundColor: ui.modalBg,
              lineHeight: 1.2,
            },
          },
        },
      },

      MuiFormHelperText: {
        styleOverrides: {
          root: {
            color: ui.textSecondary,
            marginLeft: 0,
          },
        },
      },

      /* ========================= */
      /* 🧩 MENU SIDEBAR           */
      /* ========================= */
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: ui.menuBg,
            borderRadius: 6,
            border: `1px solid ${ui.borderSubtle}`,
          },
        },
      },

      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: ui.textPrimary,

            '&:hover': {
              backgroundColor: ui.menuHoverBg,
            },

            '&.Mui-selected': {
              backgroundColor: ui.menuSelectedBg,
            },
          },
        },
      },

      MuiListSubheader: {
        styleOverrides: {
          root: {
            backgroundColor: ui.menuBg,
            color: ui.textMuted,
            fontSize: '0.85rem',
            fontWeight: 600,
          },
        },
      },

      /* ========================= */
      /* 🧱 MODAL / PAPER         */
      /* ========================= */
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: ui.modalBg,
            borderRadius: 8,
            border: `1px solid ${ui.borderSubtle}`,
          },
        },
      },

      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(15,23,42,0.85)',
            position: 'relative',

            '&::before': {
              content: '""',
              position: 'absolute',
              inset: 0,
              backdropFilter: 'blur(4px)',
              WebkitBackdropFilter: 'blur(4px)',
              zIndex: -1,
            },
          },
        },
      },

      MuiPaper: {
        styleOverrides: {
          root: {
            '&::-webkit-scrollbar': {
              width: 8,
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: ui.modalBg,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: isDark
                ? 'rgba(255,255,255,0.22)'
                : 'rgba(0,0,0,0.25)',
              border: `2px solid ${ui.modalBg}`,
            },
          },
        },
      },

      /* ========================= */
      /* 📊 DATA GRID              */
      /* ========================= */
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: 'none',
            backgroundColor: ui.surfaceBg,
            color: ui.textPrimary,
          },

          virtualScroller: {
            backgroundColor: ui.surfaceBg,
          },

          columnHeaders: {
            backgroundColor: isDark ? '#232323' : '#e5e7eb',
            color: ui.textSecondary,
            borderBottom: `1px solid ${ui.borderSubtle}`,
          },

          columnHeaderTitle: {
            fontWeight: 600,
            fontSize: '0.75rem',
            letterSpacing: '0.03em',
          },

          row: {
            backgroundColor: ui.surfaceBg,

            '&:hover': {
              backgroundColor: ui.hoverBg,
            },
          },

          cell: {
            borderBottom: `1px solid ${ui.borderSubtle}`,
            color: ui.textPrimary,
          },

          rowSelected: {
            backgroundColor: ui.selectedBg,

            '&:hover': {
              backgroundColor: ui.selectedBg,
            },
          },

          footerContainer: {
            backgroundColor: isDark ? '#232323' : '#e5e7eb',
            borderTop: `1px solid ${ui.borderSubtle}`,
            color: ui.textSecondary,
          },

          selectedRowCount: {
            color: ui.textSecondary,
          },
        },
      },

      /* ========================= */
      /* 📌 NAVBAR                 */
      /* ========================= */
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: ui.navBg,
            color: '#ffffff',
            borderBottom: `1px solid ${ui.borderSubtle}`,
            boxShadow: 'none',

            /* Íconos dentro del navbar */
            '& .MuiIconButton-root': {
              color: '#ffffff',
            },

            /* Texto (título + versión) */
            '& .MuiTypography-root': {
              color: '#ffffff',
            },

            /* Hover consistente */
            '& .MuiIconButton-root:hover': {
              backgroundColor: 'rgba(255,255,255,0.12)',
            },
          },
        },
      },

      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: 64,
            paddingLeft: 16,
            paddingRight: 16,
          },
        },
      },

      MuiIconButton: {
        styleOverrides: {
          root: {
            color: ui.textSecondary,

            '&:hover': {
              backgroundColor: ui.hoverBg,
              color: ui.textPrimary,
            },
          },
        },
      },

      /* ========================= */
      /* 👌 MIGAJAS DE PAN         */
      /* ========================= */
      MuiBreadcrumbs: {
        styleOverrides: {
          root: {
            backdropFilter: 'blur(6px)',
          },
        },
      },

      MuiLink: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
          },
        },
      },

      /* BOTONES */
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            transition: 'all 0.2s ease',
          },
          contained: {
            backgroundColor: ui.primaryAction,
            color: ui.primaryActionText,
            border: `1px solid ${ui.primaryActionBorder}`,

            '&:hover': {
              backgroundColor: ui.primaryActionHover,
              borderColor: ui.primaryActionBorderHover,
            },
          },
        },
      },
    },

    typography: {
      appTitle: {
        fontSize: '1.05rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        color: ui.titleAccent,
        userSelect: 'none',
      },
    },
  };
};
